"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.simpleMessageLocalizer = void 0;
var invariant_1 = __importDefault(require("../util/invariant"));
var configure_1 = __importDefault(require("../configure"));
var default_messages_1 = require("./default-messages");
// eslint-disable-next-line @typescript-eslint/ban-types
function getMessage(messages, path) {
  var i;
  var node = messages;
  var length = path.length;
  for (i = 0; i < length - 1; i++) {
    node = node[path[i]];
    if (typeof node === 'undefined') {
      return undefined;
    }
  }
  return node[path[i]];
}
// simple message localizer with no support for custom locales and variables
function simpleMessageLocalizer() {
  return {
    // eslint-disable-next-line @typescript-eslint/ban-types
    formatMessage: function formatMessage(path, variables, locale) {
      invariant_1.default(typeof variables === 'undefined', 'default message localizer doesn\'t support variables');
      if (locale) {
        throw new Error('[adp-react-components] You are attempting to use a widget with a non-default locale.' + 'However there is no localizer set. Please configure a message localizer.');
      }
      if (typeof path === 'string') {
        path = path.split('/');
      }
      var message = getMessage(default_messages_1.defaultMessages, path);
      if (typeof message !== 'string') {
        throw new Error('Message not found: ' + path.join('/'));
      }
      return message;
    }
  };
}
exports.simpleMessageLocalizer = simpleMessageLocalizer;
function default_1() {
  var localizer = simpleMessageLocalizer();
  configure_1.default.setMessageLocalizer(localizer);
  return localizer;
}
exports.default = default_1;